import React from "react";
import ShowAnswer from "./QuestionTypes/ShowAnswer";
import { ErrorPage } from "../../Component/ErrorPage";
import MultipleChoice from "./QuestionTypes/MultipleChoice";
import ShortAnswer from "./QuestionTypes/ShortAnswer";
import TrueFalse from "./QuestionTypes/TrueFalse";
import { Spinner } from "../../Component/Spinner";

interface QuestionDisplayProps {
    showAnswer: boolean;
    subjectUser: string;
    subjectSlug: string;
    questionType: string;
    answer: any;
    question: any;
    showError: boolean;
    showLoader: boolean;
    errorSource: string;
    errorTitle: string;
    errorDetail: string;
    selectedAnswer: boolean | string
    setSelectedAnswer: Function;
}

export default function QuestionDisplay({
    showAnswer,
    subjectUser,
    subjectSlug,
    questionType,
    answer,
    question,
    showError,
    showLoader,
    errorSource,
    errorTitle,
    errorDetail,
    selectedAnswer,
    setSelectedAnswer
}: QuestionDisplayProps) {
    if (showLoader) {
        return <Spinner show={true}/>
    }
    if (showAnswer) {
        return (
            <ShowAnswer
                answer={answer}
                question={question}
            />
        );
    }
    
    if (showError) {
        return (
            <ErrorPage
                source={errorSource}
                title={errorTitle}
                detail={errorDetail}
            />
        );
    }

    switch (questionType) {
        case "true-false":
            return (
                <TrueFalse
                    optionalContext={question.optionalContext}
                    text={question.text}
                    selectedAnswer={selectedAnswer}
                    setSelectedAnswer={setSelectedAnswer}
                ></TrueFalse>
            );
            break;
        case "short-answer":
            return (
                <ShortAnswer
                    optionalContext={question.optionalContext}
                    text={question.text}
                ></ShortAnswer>
            );
            break;
        case "multiple-choice":
            return (
                <MultipleChoice
                    optionalContext={question.optionalContext}
                    text={question.text}
                    selectedAnswer={selectedAnswer}
                    setSelectedAnswer={setSelectedAnswer}
                    question={question}
                ></MultipleChoice>
            );
            break;
        default:
            return (<></>);
            break;
    }
}
